import axios from "axios";

export const collectionTableService = {
    getCollectionTables
};

function getCollectionTables() {
    return axios.get(`${process.env.VUE_APP_API_URL}/collectionTable/all`);
}